import Joyride, { CallBackProps, Step } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

interface TutorialProps {
  tutorialKey: string;
  noSave?: boolean;
  steps: Step[];
};

export function Tutorial(props: TutorialProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial' });
  const { userData, completeTutorial } = useAppStore();

  if (userData.tutorials.includes(props.tutorialKey)) {
    return null;
  }

  const cb = (data: CallBackProps) => {
    if (data.action !== 'reset' || props.noSave) return;
    completeTutorial(props.tutorialKey);
  };

  return <Joyride
    locale={t('Joyride', { returnObjects: true }) as any}
    disableOverlayClose
    steps={props.steps}
    disableCloseOnEsc
    hideCloseButton
    callback={cb}
    continuous
  />;
}